<template>
	<footer id="footer" class="md:absolute bebas bottom-0 flex flex-col sm:flex-row items-center justify-center px-6 py-4 text-xl w-full z-r">
		<div class="flex flex-col leading-none mb-6 sm:mb-0 sm:mr-auto text-gray-0 uppercase" :class="{'md:text-gray-9' : route('home'), 'sm:text-gray-9' : route('contact')}">
			<span>
				Telefon - 05522/72989 - Auf Anmeldung
			</span>
			<span>
				Mail - kontakt@salonanger.de
			</span>
		</div>
		<div class="flex items-center leading-none text-gray-0 md:text-gray-9" :class="{'text-gray-0' : route('home'), 'sm:text-gray-9' : route('contact')}">
			<span class="mr-3"> 
				Öffnungszeiten 
			</span>
			<div class="border-l border-gray-9 flex flex-col pl-3">
				<span>
					Di - Fr : 9 - 17 Uhr
				</span>
				<span>
					Sa : 8 - 12 Uhr
				</span>
			</div>
		</div>
	</footer>
</template>

<script>
	export default {
		name: 'interface-footer'
	};
</script>
